<template>
  <div class="admin-illustrations">
    <navbar></navbar>
    <h2>Admin Illustration</h2>
    <ul>
      <li v-for="illustration in illustrations">
        {{illustration.Subject}} <b-button v-on:click="open(illustration.Slug)">Edit</b-button>
      </li>
    </ul>
    <b-button v-on:click="newillustration()">Add</b-button>
  </div>
</template>

<script>

import navbar from '@/components/navbar.vue';

export default {
  name: 'admin-illustrations',
  data () {
    return {
      illustrations : []
    }
  },
  methods: {
    // Load employee-data form webserivce
    loaddata: function () {
      this.$http.post('pIllustrationList').then(function(response) { this.illustrations = response.data; });
    },
    open: function (slug) {
      this.$router.push({ name: "AdminIllustration", params: { slug: slug }});
    },
    newillustration: function() {
      this.$router.push({ name: "AdminNewIllustration" });
    }
  },
  components: {
    'navbar': navbar
  },
  created: function() {
					this.loaddata();
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// admin-illustrations.vue?47930e22